export default __webpack_public_path__ + "static/media/brian-zheng.8308bfc3.png";